import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
const ConfirmDialog = (props) => {
  const { title, children, open, setOpen, onConfirm, variant } = props;
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
      {variant === "confirm" && (
      <>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          color="secondary"
        >
          CANCEL
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
          color="default"
        >
          CONFIRM
        </Button>
        </>
    )}
    {variant === "info" && (
      <Button color="primary" onClick={() => setOpen(false)}>
        OK
      </Button>
    )}
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDialog;